export const bailiffJobAllSelector = (state) =>
  state?.bailiffJobReducer?.bailiffJobAll;
export const bailiffJobOpenAddSelector = (state) =>
  state?.bailiffJobReducer?.bailiffJobOpenAdd;
export const bailiffJobOpenEditSelector = (state) =>
  state?.bailiffJobReducer?.bailiffJobOpenEdit;
export const bailiffJobSelectedSelector = (state) =>
  state?.bailiffJobReducer?.bailiffJobSelected;
export const bailiffJobSearchSelector = (state) =>
  state?.bailiffJobReducer?.bailiffJobSearch;
export const bailiffJobOpenPaymentSelector = (state) =>
  state?.bailiffJobReducer?.bailiffJobOpenPayment;
//
export const bailiffJobDetailSelector = (state) =>
  state?.bailiffJobReducer?.bailiffJobDetail;
export const bailiffJobBanksSelector = (state) =>
  state?.bailiffJobReducer?.bailiffJobBanks;
export const bailiffJobPreviewSelector = (state) =>
  state?.bailiffJobReducer?.bailiffJobPreview;
export const bailiffJobExtractingCountSelector = (state) =>
  state?.bailiffJobReducer?.bailiffJobExtractingCount;
